import { usePreview } from "./usePreview";
import { Loader } from "components/common/Icons/Loader/Loader";
import { Translate } from "components/common/Translate/Translate";

export const Preview = () => {
    const { previewContainerRef, initialImageRef, parentImageRef, flipRef, isLoading } = usePreview();

    return (
        <div className="mx-4 h-full">
            <div className="bg-white dark:bg-transparent flex justify-center h-full" ref={previewContainerRef}>
                <div className="h-full flex flex-col items-start lg:items-center lg:justify-center">
                    <img ref={parentImageRef} className="hidden" />
                    <img ref={initialImageRef} className="hidden" />
                    <img ref={flipRef} className={`${isLoading ? "hidden" : ""}`} data-testid={`preview-image`} />
                    {isLoading && (
                        <div
                            className="flex flex-col lg:flex-row gap-4 items-center"
                            data-testid={`preview-image-loader`}
                        >
                            <Loader className="stroke-[var(--dark-gray)]" height={35} width={35} />
                            <div>
                                <Translate keyName="loading-your-image" />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
